// Centralized site constants
export const COMPANY = {
  name: "Southern Greens Lawn Care",
  fullName: "Southern Greens Lawncare & More",
  tagline: "Professional Lawn Care You Can Count On",
  phoneDisplay: "(479) 684-8439",
  phoneRaw: "4796848439",
  telHref: "tel:+14796848439",
  hours: "Mon–Sat 7:00 AM – 7:00 PM",
  serviceArea: "Northwest Arkansas — Fayetteville, Springdale, Rogers, Bentonville & surrounding areas",
  serviceAreaShort: "Northwest Arkansas",
};

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_d1df600a-9385-4169-aa89-e92fafcb98e2/artifacts/liudi11l_679790439_122175732164818605_2951754675664812535_n.JPEG",
  heroVideo:
    "https://customer-assets.emergentagent.com/job_d1df600a-9385-4169-aa89-e92fafcb98e2/artifacts/asgk4vrm_f2a9bf54ec75401ebd21801121fc7331.MOV",
  photos: {
    bigHome:
      "https://customer-assets.emergentagent.com/job_d1df600a-9385-4169-aa89-e92fafcb98e2/artifacts/b79msktm_684492161_122176072070818605_6052316329620388107_n.JPEG",
    mowLines:
      "https://customer-assets.emergentagent.com/job_d1df600a-9385-4169-aa89-e92fafcb98e2/artifacts/grqtkt15_Tezza-3249.JPG",
    backyard:
      "https://customer-assets.emergentagent.com/job_d1df600a-9385-4169-aa89-e92fafcb98e2/artifacts/5dc2uzd0_IMG_3170.jpeg",
    fencedYard:
      "https://customer-assets.emergentagent.com/job_green-care-staging/artifacts/optjvikn_IMG_4770.JPEG",
    sideYardStripes:
      "https://customer-assets.emergentagent.com/job_green-care-staging/artifacts/4gdmxg9c_IMG_3169.jpeg",
    curbsideMow:
      "https://customer-assets.emergentagent.com/job_green-care-staging/artifacts/c5qcu4ka_IMG_4310.jpeg",
  },
  flier:
    "https://customer-assets.emergentagent.com/job_green-care-staging/artifacts/9qqbwnz6_78fb0537-dcc7-4dda-8d26-f775e1bc83db.PNG",
  credit: {
    logo: "https://customer-assets.emergentagent.com/job_green-care-staging/artifacts/obadr7d9_Untitled%20design%20%2816%29.png",
    text: "Website Designed and Operated by Tradesmen Marketing, a Division of The Tradesmen Wealth Co.",
  },
  stock: {
    mower:
      "https://images.pexels.com/photos/6728925/pexels-photo-6728925.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    blower:
      "https://images.unsplash.com/photo-1733286125300-b4c5563295ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxsZWFmJTIwYmxvd2VyJTIwbGFuZHNjYXBpbmd8ZW58MHx8fHwxNzgwNjE2MTE4fDA&ixlib=rb-4.1.0&q=85",
    weedEater:
      "https://images.pexels.com/photos/32208888/pexels-photo-32208888.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
};

export const SERVICES = [
  {
    slug: "lawn-mowing",
    title: "Lawn Mowing",
    short: "Clean, even cuts that keep your grass healthy all season long.",
    description:
      "Reliable, professional mowing with sharp blades and the right cut height for your turf. We mow on a schedule that works for you — weekly, bi-weekly, or one-time.",
    icon: "Scissors",
  },
  {
    slug: "weed-eating",
    title: "Weed Eating",
    short: "Precision trimming around fences, beds, posts, and trees.",
    description:
      "We string-trim every edge a mower can’t reach so your lawn looks finished, top to bottom. No more shaggy edges around fences, mailboxes, or flower beds.",
    icon: "Sprout",
  },
  {
    slug: "edging",
    title: "Edging",
    short: "Crisp, defined edges along driveways, sidewalks, and beds.",
    description:
      "Sharp, straight edges give your property that detailed, professionally maintained look — and help keep grass from creeping into beds and paths.",
    icon: "Ruler",
  },
  {
    slug: "blowing",
    title: "Blowing & Cleanup",
    short: "Driveways, walkways, and patios cleared every visit.",
    description:
      "After every service, we blow off clippings, dust, and debris from hard surfaces so we leave your property cleaner than we found it.",
    icon: "Wind",
  },
  {
    slug: "yard-cleanup",
    title: "Yard Cleanup",
    short: "Leaves, sticks, and debris hauled and handled.",
    description:
      "Spring and fall cleanups, storm debris removal, and one-time refresh visits. We get overgrown or neglected yards back to looking sharp.",
    icon: "Trash2",
  },
  {
    slug: "seasonal",
    title: "Seasonal Maintenance",
    short: "Year-round programs that keep your lawn at its best.",
    description:
      "Custom maintenance plans that handle mowing, trimming, edging, and seasonal cleanups so your yard always looks its best — no calls or scheduling required.",
    icon: "Calendar",
  },
  {
    slug: "residential",
    title: "Residential Lawn Care",
    short: "Dependable lawn care for homeowners across Northwest Arkansas.",
    description:
      "From small front yards to large acreage, we treat every home like our own. Friendly crews, consistent schedules, and pricing that makes sense.",
    icon: "Home",
  },
  {
    slug: "commercial",
    title: "Commercial Lawn Care",
    short: "Polished grounds for businesses, rentals, and properties.",
    description:
      "Keep your commercial property looking professional with scheduled mowing, edging, and cleanup. Curb appeal that helps your business stand out.",
    icon: "Building2",
  },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Gallery", to: "/gallery" },
  { label: "Request a Quote", to: "/quote" },
];
